import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const About = () => {
  return (
    <>
      {/* Hero Section */}
      <section
        className="about-hero text-orange bg-white"
        style={{
          padding: "10rem 0",
          textAlign: "center",
        }}
      >
        <Container>
          <h1 className="fw-bold mb-3" data-aos="fade-up" data-aos-delay="100">
            About Intelisparkz
          </h1>
          <p className="lead mb-0" data-aos="fade-up" data-aos-delay="200">
            Empowering innovation with technology. Building tomorrow, today.
          </p>
        </Container>
      </section>

      {/* Who We Are */}
      <section className="section">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col
              md={10}
              data-aos="fade-up"
              data-aos-delay="200"
              data-aos-duration="1000"
            >
              <h3 className="fw-bold text-dark mb-3">Who We Are</h3>
              <p className="text-muted">
                InteliSparkz Systems is a technology company specialising in
                enterprise software for industry, defense, and public-sector
                organisations. We design and deploy secure, on-premise solutions
                — inventory and asset management, document and quality
                management, and access-control systems — built for
                mission-critical environments.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Mission & Vision */}
      <section className="section">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col
              md={10}
              data-aos="fade-right"
              data-aos-delay="200"
              data-aos-duration="1000"
            >
              <h3 className="fw-bold text-dark mb-3">Our Mission</h3>
              <p className="text-muted">
                To digitise mission-critical operations for industry and defense
                through secure, reliable, and locally-deployable software.
              </p>
              <h3 className="fw-bold text-dark mt-4 mb-3">Our Vision</h3>
              <p className="text-muted">
                To be the trusted technology partner for India's industrial and
                public-sector organisations.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* What We Do */}
      <section className="services-section section bg-light">
        <Container>
          <div className="text-center mb-5">
            <h3 className="fw-bold text-dark">What We Do</h3>
            <p className="text-muted">
              Delivering value through services that shape your future.
            </p>
          </div>
          <Row className="text-center">
            {[
              {
                title: "Inventory & Asset Management",
                desc: "AI-driven stock traceability, GRN tracking, and predictive restocking with Intelistock & InteliTrack.",
              },
              {
                title: "Document & Drawing Management",
                desc: "Secure versioning, approvals, and audit trails for engineering records via inteliDoc.",
              },
              {
                title: "Access Control & Security",
                desc: "Facial recognition, QR validation, and gate integration with InteliPass & InteliShuttle.",
              },
              {
                title: "Quality Management Systems",
                desc: "Digital ATP/NCR workflows and audit compliance for defense & aerospace with InteliQMS.",
              },
              {
                title: "IoT & Smart Infrastructure",
                desc: "Sensor-based deployments, RFID/GPS tracking, and edge integration for industrial sites.",
              },
              {
                title: "On-Prem & Secure Deployment",
                desc: "Air-gapped, cloud-free architectures aligned with public-sector security policies.",
              },
            ].map((service, index) => (
              <Col
                md={4}
                className="mb-4"
                key={index}
                data-aos="fade-up"
                data-aos-delay={100 + index * 100}
                data-aos-duration="1000"
              >
                <div className="glass-service-card p-4 h-100 text-white">
                  <h5 className="fw-bold mb-2">{service.title}</h5>
                  <p className="small mb-0">{service.desc}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default About;
